import getPageData from "./getPageData";
import nameCityToCode from './nameCityToCode'

export default async function (cityCode) {

  try {

    const pageData = await getPageData();

    const { cityInfo } = pageData;

    cityCode = nameCityToCode(cityCode);

    return cityInfo.find(inf => nameCityToCode(inf.nomeCidade) === cityCode);

  }catch (e) { throw e; }
}
